// extracted by mini-css-extract-plugin
module.exports = {"successMsg":"HZac5","icon":"HZaj","infoWrapper":"HZach","title":"HZal","content":"HZbd","top":"HZkf","bottom":"HZf1"};